var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"registration"},[_c('div',{staticClass:"registration__container container"},[_c('div',{staticClass:"registration__title"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.tr.registration.title)}})]),_c('vButton',{staticClass:"registration__btn",attrs:{"href":_vm.urlToPartner(),"target":"_blank","xLarge":"","white":""}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }